/* Resilia only: keep the single-variant bundle total in the visible PDP price.
 * Independent of general product/checkout/cart logic. */
(() => {
  'use strict';
  const selector = 'quantity-breaks[data-retrowave-resilia-pricing="true"][data-update-pdp-prices="true"]';
  const mounted = new WeakSet();
  const money = cents => {
    const currency = window.Shopify?.currency?.active || window.ShopifyAnalytics?.meta?.currency || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency}).format(cents / 100); }
    catch (_) { return '$' + (cents / 100).toFixed(2); }
  };
  function selection(qb) {
    const checked = qb.querySelector('input[type="radio"][name="quantity"]:checked');
    if (!checked) return null;
    // Shopify puts the corresponding label immediately after each input.
    const label = checked.nextElementSibling?.matches('label.quantity-break')
      ? checked.nextElementSibling
      : [...qb.querySelectorAll('label.quantity-break')].find(node => node.htmlFor === checked.id);
    const base = Number(qb.dataset.basePrice);
    const qty = Number(checked.value);
    const multiplier = Number(label?.dataset.percentageLeft);
    const fixed = Number(label?.dataset.fixedDiscount || 0);
    const compareBase = Number(label?.dataset.baseComparePrice);
    if (!label || !Number.isFinite(base) || base <= 0 || !Number.isInteger(qty) || qty < 1 || !Number.isFinite(multiplier)) return null;
    const price = Math.max(0, Math.round(base * qty * multiplier - fixed));
    const compare = (Number.isFinite(compareBase) && compareBase > 0 ? compareBase : base) * qty;
    return {price, compare};
  }
  function priceWrap(qb) {
    const section = qb.dataset.section;
    if (!section) return null;
    // Shopify section IDs are unique; use exact DOM ids, not global class selectors.
    const scoped = qb.closest('quick-add-modal') || qb.closest('.shopify-section') || document;
    return scoped.querySelector?.(`[id="price-${section}"]`) || document.getElementById(`price-${section}`);
  }
  function setText(element, value) {
    if (element && element.textContent.trim() !== value) element.textContent = value;
  }
  function render(qb) {
    if (!qb.isConnected) return;
    const amount = selection(qb);
    const wrap = priceWrap(qb);
    if (!amount || !wrap) return;
    const formattedPrice = money(amount.price);
    const formattedCompare = money(amount.compare);
    wrap.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale')
      .forEach(node => setText(node, formattedPrice));
    wrap.querySelectorAll('.price__compare-price .price-item--regular')
      .forEach(node => setText(node, formattedCompare));
    wrap.querySelectorAll('.price').forEach(node => {
      const onSale = amount.compare > amount.price;
      if (node.classList.contains('price--on-sale') !== onSale) node.classList.toggle('price--on-sale', onSale);
    });
  }
  function mount(qb) {
    if (mounted.has(qb)) return;
    mounted.add(qb);
    const update = () => render(qb);
    qb.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"][name="quantity"]')) queueMicrotask(update);
    });
    // Shrine sometimes replaces the inner price HTML after our initial sync.
    // Observe only this single product's price block; writes are equality-guarded.
    const wrap = priceWrap(qb);
    if (wrap) {
      const observer = new MutationObserver(() => {
        if (!qb.isConnected) {observer.disconnect(); return;}
        update();
      });
      observer.observe(wrap, {subtree:true, childList:true, characterData:true});
    }
    update();
    requestAnimationFrame(update);
  }
  function scan(root=document) {
    if (root.matches?.(selector)) mount(root);
    root.querySelectorAll?.(selector).forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once:true});
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('retrowave:quick-add:ready', event => scan(event.target));
})();
